import { fromJS } from 'immutable';
import * as constants from './template-list-constants';
import R from 'ramda';
import { getTemplateStatus } from '../../../components/contracting/contractingUtils';
const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const createDraftInitialData = {
  dialogOpen: false,
  openCreateFirstDraft: false,
  newDraftStartDate: undefined,
  newDraftEndDate: undefined,
  newDraftName: '',
  createDraftError: '',
  creatingDraft: false,
  quickStartSelected: { type: 'custom' },
};
const createTemplateGroupInitialDate = {
  selectedContractPeriod: {},
  newGroupName: '',
  createGroupError: '',
  creatingGroup: false,
  newGroupStartDate: '',
  newGroupEndDate: '',
  loadingForGroupWizard: false,
  groupWizardStep: 0,
  groupWizardTemplates: [],
  selectedTemplatesForGroup: [],
  groupCreated: false,
};
const editTemplateGroupInitialDate = {
  editGroupName: '',
  editGroupId: '',
  editGroupStartDate: '',
  editGroupEndDate: '',
  selectedTemplatesForGroup: [],
  editDialogOpen: false,
  editGroupError: '',
  updatingGroup: false,
  groupUpdated: false,
  groupWizardTemplates: [],
};
const initialState = fromJS({
  listRefreshing: false,
  templatesLoaded: false,
  showLoadingOverlay: false,
  searchingAllYears: true,
  templateListPage: 1,
  templateGroups: [],
  templates: [],
  allContractPeriods: [],
  statusesFilter: [],
  drafts: [],
  locations: [],
  createTemplateGroupOpen: false,
  sendTemplateDialogOpen: false,
  templateToBeSent: {},
  templateGroupToBeSent: {},
  ...createDraftInitialData,
  ...createTemplateGroupInitialDate,
  ...editTemplateGroupInitialDate,
});

const templateList = (state = initialState, { type, payload, ...extraPayload }) => {
  switch (type) {
    case '[contracting]SELECTED_YEAR_FOR_CONTRACTING':
      if (extraPayload.currentRoute && extraPayload.currentRoute.indexOf('template-list') > -1) return state.set('searchingAllYears', false);
      return state;
    case 'ARCHIVE_UNARCHIVE_TEMPLATE_SUCCESS':
      return state.update('templates', templates => {
        return templates.map(template => {
          if (template.get('_id') === payload.templateId) return template.set('isArchived', payload.isArchived);
          return template;
        });
      });
    case constants.TEMPLATE_DELETED:
      return state.update('templates', templates => templates.filter(template => template.get('_id') !== payload.templateId));
    case constants.UPDATING_TEMPLATE_NAME:
      return state.update(`${payload.templateOrDraft}s`, docs => docs.map(doc => {
        if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
        return doc.set('savingName', !doc.get('savingName'));
      }));
    case constants.TEMPLATE_NAME_UPDATED:
      return state.update(`${payload.templateOrDraft}s`, docs => docs.map(doc => {
        if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
        return doc.merge(fromJS({ templateName: payload.newName, errorText: '', showEditNameConfirmButton: false, savingName: false, showDeleteConfirmButton: false }));
      }));
    case constants.TEMPLATE_NAME_UPDATED_DUPLICATED:
      return state.update(`${payload.templateOrDraft}s`, docs => docs.map(doc => {
        if (doc.get(payload.templateOrDraft === 'draft' ? 'originalContractId' : '_id') !== payload.templateId) return doc;
        return doc.merge(fromJS({ errorText: 'Duplicate Name', savingName: false, showDeleteConfirmButton: false }));
      }));
    case constants.DRAFT_DELETED:
      return state.update('drafts', drafts => drafts.filter(draft => draft.get('originalContractId') !== payload.draftId));
    case constants.UPDATE_DRAFT_PROPS:
      return state.update('drafts', drafts => drafts.map(draft => {
        if (draft.get('originalContractId') === payload.draftId) return draft.merge(fromJS(payload.data));
        return draft;
      }));
    case constants.UPDATE_TEMPLATE_PROPS:
      return state.update('templates', templates => templates.map(template => {
        if (template.get('_id') === payload.templateId) return template.merge(fromJS(payload.data));
        return template;
      }));
    case constants.UPDATE_FILTERS:
      return state.merge(fromJS({
        searchInput: payload.searchInput,
        statusesFilter: payload.statusesFilter || [],
        showType: payload.showType,
        searchingAllYears: R.isNil(payload.searchingAllYears) ? true : payload.searchingAllYears,
      }))
    case constants.UPDATE_PROPS:
      return state.merge(fromJS(payload));
    case constants.LOADING_DRAFTS:
    case constants.LOADING_TEMPLATES:
      return state.merge(fromJS({
        listRefreshing: !state.get('listRefreshing'),
        showLoadingOverlay: state.get('templatesLoaded') ? state.get('showLoadingOverlay') : !state.get('showLoadingOverlay'),
      }));
    case constants.GET_SUPPLIER_LOCATIONS_LIST:
      return state.set('locations',
        R.call(R.compose(
          locs => fromJS(locs),
          R.append({
            name: '',
            products: [],
          }),
          R.sortBy(R.compose(R.toLower, R.prop('name'))),
          R.map(loc => {
            return R.merge(loc, {
              checked: payload.locationId ? (loc.locationId === payload.locationId) : R.contains('write', loc.access),
              products: loc.products.map(R.assoc('checked', payload.locationId ? (loc.locationId === payload.locationId) : R.contains('write', loc.access))),
            });
          })
        ), payload.locations));
    case constants.UPDATE_LOC_PROPS:
      return state.update('locations', locations => locations.map(loc => {
        if (loc.get('locationId') === payload.locationId) return loc.merge(fromJS(payload.value));
        return loc;
      }));
    case '{template-list} REFRESH_TEMPLATE_LIST_SUCCESS':
    case constants.TEMPLATES_LOADED:
      return state.merge(fromJS({
        templates: payload.templates.map(obj => R.merge(obj, { shownStatus: getTemplateStatus(obj) })),
        drafts: payload.drafts.map(obj => R.merge(obj, { shownStatus: getTemplateStatus(obj) })),
        templateGroups: payload.templateGroups,
        listRefreshing: false,
        showLoadingOverlay: false,
        templatesLoaded: true,
      }));
    case constants.POPULATE_CONTRACTS_COUNT:
      return state.update('templates', templates => templates.map(template => {
        if (template.get('_id') === payload.templateId) return template.merge(payload);
        return template;
      }));
    case constants.STARTING_DRAFT_CREATE:
      return state.set('creatingDraft', !state.get('creatingDraft'));
    case constants.DRAFT_CREATED:
      return state.merge(fromJS(createDraftInitialData));
    case constants.GOT_ALL_CONTRACT_PERIODS:
      return state.set('allContractPeriods', fromJS(payload.contractPeriods));
    case constants.TEMPLATES_LOADED_FOR_WIZARD:
      return state.set('groupWizardTemplates', fromJS(payload.templates))
        .set('loadingForGroupWizard', false);
    case constants.LOADING_TEMPLATES_FOR_WIZARD:
      return state.set('loadingForGroupWizard', !state.get('loadingForGroupWizard'));
    case constants.STARTING_TEMPLATE_GROUP_CREATION:
      return state.set('creatingGroup', !state.get('creatingGroup'));
    case constants.TEMPLATE_GROUP_CREATED:
      return state.set('creatingGroup', false)
        .set('groupCreated', true);
    case constants.TEMPLATE_GROUP_UPDATED:
      return state.merge(fromJS(editTemplateGroupInitialDate));
    case constants.DOWNLOADING_PDF_ZIP:
      return state.set('showLoadingOverlay', true)
        .set('overlayText', `Please be patient, as this download may take a few minutes.\n\n\nWhile you wait...\n\n\nFun Fact: Tourism accounts for five percent of the world’s economy.`);
    case constants.PDF_ZIP_DOWNLOADED:
      return state.set('showLoadingOverlay', false)
        .set('overlayText', '');
    case 'TEMPLATE_GROUP_CREATION_UNMOUNT':
      return state.merge(fromJS(createTemplateGroupInitialDate));
    default:
      return state;
  }
};

export default templateList;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/template-list/template-list-reducer.js